import _ from "lodash";

export class Month {
  year: number;
  month: number;

  constructor(year: number, month: number) {
    this.year = year;
    this.month = month;
  }

  lessThan({ year, month }: Month): boolean {
    if (this.year < year) {
      return true;
    }

    if (this.year === year) {
      return this.month < month;
    }

    return false;
  }

  toString(): string {
    return `${this.year.toString().padStart(4, "0")}-${this.month.toString().padStart(2, "0")}`;
  }

  static fromString(monthString: string): Month {
    const [yearStr, monthStr] = monthString.split("-");

    return new Month(parseInt(yearStr), parseInt(monthStr));
  }

  next(): Month {
    if (this.month === 12) {
      return new Month(this.year + 1, 1);
    }

    return new Month(this.year, this.month + 1);
  }
}

export function fillInMissingMonthlyBuckets<D extends { month: Month }>(
  data: D[]
): (D | { month: Month })[] {
  if (data.length === 0 || data.length === 1) {
    return data;
  }
  const dataByMonth = _.keyBy(data, element => element.month.toString());

  const minMonth = data[0].month;
  const maxMonth = data[data.length - 1].month;

  const res: (D | { month: Month })[] = [];
  let month = minMonth;
  while (month.lessThan(maxMonth)) {
    const monthString = month.toString();
    if (dataByMonth[monthString]) {
      res.push(dataByMonth[monthString]);
    } else {
      res.push({
        month,
      });
    }

    month = month.next();
  }

  return res;
}
